import request from "@/utils/request";
export function getForumTree() {
  return request({
    url: "/forums/tree",
    method: "get",
  });
}
export function getForumTop() {
  return request({
    url: "/forums/top",
    method: "get",
  });
}

export function getCommunity(aliase) {
  return request({
    url: "/forums/community",
    method: "get",
    params: { aliase },
  });
}
export function getForum(id) {
  return request({
    url: "/forums/forum",
    method: "get",
    params: { id },
  });
}
